import { Tooltip } from '@mui/material';
import React from 'react';

interface IProps {
  title: string;
  children: React.ReactElement;
  isDisabled?: boolean;
}

export const TableTooltip: React.FC<IProps> = ({ title, children, isDisabled = false }) => {
  return (
    <Tooltip
      title={title}
      placement="top"
      arrow
      disableHoverListener={isDisabled}
      disableInteractive
      slotProps={{
        tooltip: {
          sx: {
            borderRadius: '4px',
            px: 1,
            py: 0.5,
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};
